import axios from 'axios'
import {UposlenikModel} from '../models/UposlenikModel'
import {getAuth} from '../modules/auth'

import {ParamsModelStanjePalete, StanjePaleteModel} from '../models/StanjePaleteModel'

const API_URL = process.env.REACT_APP_API_URL
const API = `${API_URL}/stanjePalete`
const auth: UposlenikModel = getAuth()!
const headers = {Accept: 'application/json', Authorization: auth?.access_token ?? ''}

export async function getStanjePalete(params: ParamsModelStanjePalete) {
  return await axios.get<Array<StanjePaleteModel>>(API, {headers: headers, params: params})
}
